class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.endDate = this.getAttribute("data-date");
    this.type = this.getAttribute("data-type") || "default";
    this.showDays = this.getAttribute("data-show-days") === "true";
    this.showHours = this.getAttribute("data-show-hours") === "true";
    this.showMinutes = this.getAttribute("data-show-minutes") === "true";
    this.showSeconds = this.getAttribute("data-show-seconds") === "true";
    this.textDay = (this.getAttribute("data-text-day") || "Days").split(",");
    this.textHour = (this.getAttribute("data-text-hour") || "Hours").split(",");
    this.textMinute = (
      this.getAttribute("data-text-minute") || "Minutes"
    ).split(",");
    this.textSecond = (
      this.getAttribute("data-text-second") || "Seconds"
    ).split(",");
    this.interval = null;

    if (!this.endDate) {
      this.innerHTML = "No end date specified";
      return;
    }

    this.startCountdown();
  }

  startCountdown() {
    this.updateCountdown();

    this.interval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const endTime = new Date(this.endDate).getTime();
    const timeLeft = endTime - now;

    if (timeLeft <= 0) {
      this.innerHTML = this.formatExpiredMessage();
      this.classList.add("countdown-expired");
      if (this.interval) {
        clearInterval(this.interval);
      }
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    if (this.type === "compact") {
      this.innerHTML = this.formatCompactCountdown(
        days,
        hours,
        minutes,
        seconds
      );
    } else {
      this.innerHTML = this.formatCountdown(days, hours, minutes, seconds);
    }
  }

  formatCompactCountdown(days, hours, minutes, seconds) {
    const parts = [];

    if (this.showDays && days > 0) {
      const dayText =
        days === 1 ? this.textDay[0] : this.textDay[1] || this.textDay[0];
      parts.push(`${days} ${dayText}`);
    }

    if (this.showHours && (hours > 0 || days > 0)) {
      const hourText =
        hours === 1 ? this.textHour[0] : this.textHour[1] || this.textHour[0];
      parts.push(`${hours.toString().padStart(2, "0")} ${hourText}`);
    }

    if (this.showMinutes && (minutes > 0 || hours > 0 || days > 0)) {
      const minuteText =
        minutes === 1
          ? this.textMinute[0]
          : this.textMinute[1] || this.textMinute[0];
      parts.push(`${minutes.toString().padStart(2, "0")} ${minuteText}`);
    }

    if (this.showSeconds) {
      const secondText =
        seconds === 1
          ? this.textSecond[0]
          : this.textSecond[1] || this.textSecond[0];
      parts.push(`${seconds.toString().padStart(2, "0")} ${secondText}`);
    }

    return `<div class="countdown-container">${parts.join(" ")}</div>`;
  }

  formatCountdown(days, hours, minutes, seconds) {
    const timeUnits = [];

    if (this.showDays && days > 0) {
      timeUnits.push({
        value: days,
        label:
          days === 1 ? this.textDay[0] : this.textDay[1] || this.textDay[0],
      });
    }

    if (this.showHours && (hours > 0 || days > 0)) {
      timeUnits.push({
        value: hours.toString().padStart(2, "0"),
        label:
          hours === 1 ? this.textHour[0] : this.textHour[1] || this.textHour[0],
      });
    }

    if (this.showMinutes && (minutes > 0 || hours > 0 || days > 0)) {
      timeUnits.push({
        value: minutes.toString().padStart(2, "0"),
        label:
          minutes === 1
            ? this.textMinute[0]
            : this.textMinute[1] || this.textMinute[0],
      });
    }

    if (this.showSeconds) {
      timeUnits.push({
        value: seconds.toString().padStart(2, "0"),
        label:
          seconds === 1
            ? this.textSecond[0]
            : this.textSecond[1] || this.textSecond[0],
      });
    }

    return this.createStyledCountdown(timeUnits);
  }

  createStyledCountdown(timeUnits) {
    const countdownHTML = timeUnits
      .map(
        (unit) => `
      <div class="countdown-unit">
        <div class="countdown-value">${unit.value}</div>
        <div class="countdown-label">${unit.label}</div>
      </div>
    `
      )
      .join("");

    return `
      <div class="countdown-container">
        ${countdownHTML}
      </div>
    `;
  }

  formatExpiredMessage() {
    return "";
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

if (!window.customElements.get("countdown-timer")) {
  window.customElements.define("countdown-timer", CountdownTimer);
}
